module.exports = __webpack_public_path__ + "static/img/step1-1440px.168c6a4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/ChoosePhoto/img/step1-1440px.svg
// module id = 446
// module chunks = 0